import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { gradientTextValentine } from '@/lib/gradientText';

const useStyles = createUseStyles(
  {
    header: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s8,
      marginTop: Spacings.s16,
      '& h1': {
        textTransform: 'uppercase',
        ...gradientTextValentine,
      },
    },
    section: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      paddingTop: Spacings.s8,
      paddingBottom: Spacings.s8,
    },
  },
  { name: 'category-layout' },
);

export default useStyles;
